import React from "react";
import styled from "styled-components";
import {coolBackgroundColour, subduedTextColour, widgetBorderColour} from "../../../style/styleConsts";
import LoggingLink from "../../elements/LoggingLink";

export const DisabledLinkText = styled.div`
    color: ${subduedTextColour}
`;

export const NavigationContainer = styled.div`
    display: flex;
    justify-content: space-between; 
    align-self: flex-end;
    align-items: center;
    width: 250px;
    background: ${coolBackgroundColour};
    border: 1px solid ${widgetBorderColour};
    border-radius: 3px;
    padding: 4px 6px;
    margin-bottom: 12px;
`;

const CurrentPageText = styled.div`
  color: ${subduedTextColour};
  font-weight: bold;
`;

const NavigationButton = styled(LoggingLink)`
  text-decoration: none;
  color: inherit;
`;

const TextContainer = styled.div`
    display: flex;
    align-items: center;
`;

const BoldText = styled.div`
    font-weight: bold;
`;

const LeftArrowContainer = styled.div`
    margin-right: 8px;
    margin-bottom: 1px;
`;

const RightArrowContainer = styled.div`
    margin-left: 8px;
    margin-bottom: 1px;
`;

function scrollToTopFunction() {
    window.scrollTo(0, 0);
}

const ButtonContainer = ({children}) => {
    return <div onClick={scrollToTopFunction}>
        {children}
    </div>
};

const Pagination = ({totalPages, pageNumber, pageNumberToUrlFunction, loggingPayload}) => {
    const previousPage = pageNumber - 1;
    const previousLink = pageNumberToUrlFunction(previousPage);
    const nextPage = pageNumber + 1;
    const nextLink = pageNumberToUrlFunction(nextPage);
    const currentPageText = `${pageNumber} of ${totalPages}`;

    const previousText = <TextContainer>
        <LeftArrowContainer>{"\u25C2"}</LeftArrowContainer>
        <BoldText>Previous</BoldText>
    </TextContainer>;

    const previousLinkElement = pageNumber < 2 ? <DisabledLinkText className="t-previous-page">{previousText}</DisabledLinkText> :
                                <NavigationButton className="t-previous-page"
                                                  to={previousLink}
                                                  loggingPayload={{
                                                      ...loggingPayload,
                                                      action: "previous",
                                                      targetPageNumber: previousPage
                                                  }}>
                                    {previousText}
                                </NavigationButton>;

    const nextText = <TextContainer>
        <BoldText>Next</BoldText>
        <RightArrowContainer>{"\u25B8"}</RightArrowContainer>
    </TextContainer>;

    const nextLinkElement = pageNumber >= totalPages ? <DisabledLinkText className="t-next-page">{nextText}</DisabledLinkText> :
                            <NavigationButton className="t-next-page"
                                              to={nextLink}
                                              loggingPayload={{
                                                  ...loggingPayload,
                                                  action: "next",
                                                  targetPageNumber: nextPage
                                              }}>
                                {nextText}
                            </NavigationButton>;

    return (<NavigationContainer>
        <ButtonContainer>{previousLinkElement}</ButtonContainer>
        <CurrentPageText className="t-current-page">{currentPageText}</CurrentPageText>
        <ButtonContainer>{nextLinkElement}</ButtonContainer>
    </NavigationContainer>);
};


export default Pagination;